import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatCurrency0Digit } from "../../../../utility/Utils";
import Avatar from "@components/avatar";
import classnames from "classnames";
import {
  ArrowLeft,
  CheckCircle,
  Delete,
  Info,
  PieChart,
  Edit,
  Trash2,
  CreditCard,
} from "react-feather";
import { Row, Col, CardText, UncontrolledTooltip, Button } from "reactstrap";
import UILoader from "@components/ui-loader";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getCourseDetail, saveCourseRegistration } from "../action";
import DOMPurify from "dompurify";
import MySwalBlockUi from "@pageUtils/block-ui";

const MySwal = withReactContent(Swal);

const confirmRegistrationSuccess = ({ title }) => {
  return MySwal.fire({
    title: title,
    text: "",
    icon: "success",
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const confirmRegistrationError = ({ statusCode, statusDesc }) => {
  return MySwal.fire({
    title: "ลงทะเบียนไม่สำเร็จ",
    text: statusDesc,
    icon: "error",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const handleConfirmText = ({ callbackFunction, title, text }) => {
  return MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then(function (result) {
    if (result.value) {
      callbackFunction();
    }
  });
};

const CourseDetail = (props) => {
  const {
    data,
    transactionCourseUser,
    getCourseDetail,
    deleteWishlistItem,
    dispatch,
    addToWishlist,
    getProduct,
    productId,
    addToCart,
  } = props;

  const [selectedColor, setSelectedColor] = useState("primary");
  const [userData, setUserData] = useState(null);

  const handleWishlist = (val) => {
    if (val) {
      dispatch(deleteWishlistItem(productId));
    } else {
      dispatch(addToWishlist(productId));
    }
    dispatch(getProduct(productId));
  };

  const handleCartBtn = (id, val) => {
    if (val === false) {
      dispatch(addToCart(id));
    }
    dispatch(getProduct(productId));
  };

  const CartBtnTagRegistration = "button-registration";
  const CartBtnTagPayment = "button-payment";
  const CartBtnTagCancel = "button-cancel";

  //PENDING, AVAILABLE, CLOSE
  const invoiceStatusObj = {
    AVAILABLE: {
      color: "light-success",
      icon: CheckCircle,
      text: "เปิดรับสมัคร",
    },
    CANCEL: { color: "light-danger", icon: Delete, text: "ยกเลิกหลักสูตร" },
    CLOSE: { color: "light-danger", icon: Info, text: "ปิดรับสมัคร" },
    PENDING: {
      color: "light-warning",
      icon: PieChart,
      text: "ยังไม่เปิดรับสมัคร",
    },
  };

  function callBackFunctionRegistration({ type, data }) {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ลงทะเบียนเรียบร้อย" });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  function callBackFunctionCancel({ type, data }) {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ยกเลิกการลงทะเบียนเรียบร้อย" });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  }

  function cancelCourseRegistrationActionConfirm() {
    saveCourseRegistration({
      courseId: data.id,
      dispatch: dispatch,
      transactionCourseUserStatus: "CANCEL",
      callBackFunction: callBackFunctionCancel,
    });
  }

  function saveCourseRegistrationActionConfirm() {
    saveCourseRegistration({
      courseId: data.id,
      dispatch: dispatch,
      transactionCourseUserStatus: "WAIT_PAYMENT",
      callBackFunction: callBackFunctionRegistration,
    });
  }

  function saveCourseRegistrationAction() {
    handleConfirmText({
      callbackFunction: saveCourseRegistrationActionConfirm,
      title: "ต้องการลงทะเบียน ใช่หรือไม่",
      text: "",
    });
  }

  function cancelCourseRegistrationAction() {
    handleConfirmText({
      callbackFunction: cancelCourseRegistrationActionConfirm,
      title: "ต้องการยกเลิกการลงทะเบียน ใช่หรือไม่",
      text: "",
    });
  }

  useEffect(() => {
    // const blockUi = MySwalBlockUi();
    setUserData(JSON.parse(localStorage.getItem("userData")));
    //blockUi.close();
  }, []);

  const generateCourses = () => {
    const color = invoiceStatusObj[data.status]
        ? invoiceStatusObj[data.status].color
        : "primary",
      Icon = invoiceStatusObj[data.status]
        ? invoiceStatusObj[data.status].icon
        : Edit;
    const textTooltip = invoiceStatusObj[data.status]
      ? invoiceStatusObj[data.status].text
      : "แก้ไข";
    return (
      <Row className="my-2">
        <Col
          className="align-items-center justify-content-center mb-2 mb-md-0"
          md="6"
          xs="12"
        >
          <div className="align-items-center justify-content-center">
            <img
              className="img-fluid product-img"
              src={data.imageCourse}
              alt={data.courseName}
            />
          </div>
        </Col>
        <Col md="6" xs="12">
          <h4>{data.courseName}</h4>
          {userData &&
          userData.role === "admin" &&
          data.price &&
          data.price > 0 ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              {data.price1 && data.price1 > 0
                ? "ค่าลงทะเบียน (สมาชิก " +
                  data.memberName +
                  ") " +
                  formatCurrency0Digit(data.price1) +
                  " บาท"
                : "ฟรี"}
            </div>
          ) : null}
          {userData &&
          userData.role === "admin" &&
          data.price &&
          data.price > 0 ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              {data.price2 && data.price2 > 0
                ? "ค่าลงทะเบียน (สมาชิกนอกเครือข่าย " +
                  data.memberName +
                  ") " +
                  formatCurrency0Digit(data.price2) +
                  " บาท"
                : "ฟรี"}
            </div>
          ) : null}
          {userData &&
          data.courseIsMember === true &&
          userData.role === "user" &&
          data.price &&
          data.price > 0 ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              {data.price1 && data.price1 > 0
                ? "ค่าลงทะเบียน (สมาชิก " +
                  data.memberName +
                  ") " +
                  formatCurrency0Digit(data.price1) +
                  " บาท"
                : "ฟรี"}
            </div>
          ) : null}
          {userData &&
          userData.role === "user" &&
          data.courseIsMember !== true &&
          data.price &&
          data.price > 0 ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              {data.price2 && data.price2 > 0
                ? "ค่าลงทะเบียน (สมาชิกนอกเครือข่าย " +
                  data.memberName +
                  ") " +
                  formatCurrency0Digit(data.price2) +
                  " บาท"
                : "ฟรี"}
            </div>
          ) : null}
          <br />
          <CardText className="item-description">
            <Avatar
              color={color}
              icon={<Icon size={16} />}
              id={`av-tooltip-${data.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`av-tooltip-${data.id}`}
            >
              <span className="font-weight-bold">{textTooltip}</span>
            </UncontrolledTooltip>
            สถานะ : {textTooltip}
          </CardText>
          <CardText>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.description) }} />
          </CardText>
          {(transactionCourseUser &&
              (transactionCourseUser.status === "PAYMENT_SUCCESS" ||
                  transactionCourseUser.status === "APPROVE_SUCCESS")) ||
              (userData && userData.role === "admin") ? (
            <CardText>
              <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.privateDescription) }}
              />
            </CardText>
          ) : null}
          <hr />
          <div className="d-flex flex-colmn flex-sm-row pt-1">
            {userData &&
              userData.role === "user" &&
              data.status === "AVAILABLE" &&
              // ตรวจสอบว่า ID มหาวิทยาลัยของผู้ใช้ อยู่ในรายการ universityInHouse หรือไม่
              (Array.isArray(data.universityInHouse) 
                ? data.universityInHouse.map(String).includes(String(userData.university.id))
                : String(data.universityInHouse).split(',').map(s => s.trim()).includes(String(userData.university.id))
              ) &&
              !transactionCourseUser ? (
                <Button
                  color="primary"
                  className="btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0"
                  onClick={() => saveCourseRegistrationAction()}
                >
                  <CheckCircle className="mr-50" size={14} />
                  ลงทะเบียน
                </Button>
            ) : null}
            {userData &&
            userData.role === "user" &&
            transactionCourseUser &&
            transactionCourseUser.status === "WAIT_PAYMENT" ? (
              <Link
                tag={CartBtnTagCancel}
                className="btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0 btn btn-success"
                to={{ pathname: "/payment-detail", state: { courseId: data.id, transactionCourseUserId: transactionCourseUser.id } }}
              >
                <CreditCard className="mr-50" size={14} />
                ชำระค่าลงทะเบียน
              </Link>
            ) : null}
            {userData &&
            userData.role === "user" &&
            transactionCourseUser &&
            transactionCourseUser.status === "WAIT_PAYMENT" ? (
              <Button
                color="danger"
                className="btn-cart mr-0 mr-sm-1 mb-1 mb-sm-0"
                onClick={() => cancelCourseRegistrationAction()}
              >
                <Trash2 className="mr-50" size={14} />
                ยกเลิกการลงทะเบียน
              </Button>
            ) : null}
            <Link
              className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0 btn btn-outline-secondary"
              outline
              to="/course-in-house"
            >
              <ArrowLeft size={14} className={classnames("mr-50")} />
              <span>กลับ</span>
            </Link>
          </div>
        </Col>
      </Row>
    );
  };

  return <div>{generateCourses()}</div>;
};

export default CourseDetail;
